import * as React from 'react';
import Icon from '@material-ui/core/Icon';
import "./index.scss";

//interface function void


class Sidebar extends React.Component{ 
    render() {
        const { toggleMenuVisibleMobile, menuVisibleMobile, toggleSidebarVisible, sidebarVisible, children } = this.props;
        return (
            <>
                <div onClick={toggleMenuVisibleMobile} className={menuVisibleMobile ? 'sidenav-overlay sidenav-overlay-show' : 'sidenav-overlay'}></div>

                <div className={menuVisibleMobile ? 'sidenav sidenav-show-mobile' : 'sidenav'}>

                    <Icon
                        className={!sidebarVisible ? 'toggle-menu-icon to-right' : 'toggle-menu-icon'}
                        onClick={toggleSidebarVisible}>{!sidebarVisible ? 'keyboard_arrow_right' : 'keyboard_arrow_left'}
                    </Icon>

                    {children}
                </div>
            </>
        )
    }
}

export default Sidebar;